import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import {Title} from '@kion/data-models';

export const loadAllSuccess = createActionWithCorrelation(
  "[Title] loadAll Success",
  props<{ titles: Title[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[Title] loadAll Error",
  props<{error: any}>()
);
export const loadAll = createActionWithCorrelation(
  "[Title] loadAll",
  loadAllSuccess.type,
  loadAllError.type,
);
